import React from 'react'
import { Column } from 'react-table'
import { Link } from 'react-router-dom'
import { Employer, InterimAgency } from '../../api/organizations'
import Table from '../table'
import RoleStatus from '../users/role-status'
import { formatCompleteDate } from '../../utils/date'
import { isAuthorizedFor } from '../protected/protected'
import { compareDocsById } from '../../utils/documents'
import { ResourceLinkCell } from '../table/cells'

interface AssociationsTableProps {
  organizations: Employer[]
  interimAgency: InterimAgency
  itemPath?: string
}

/**
 * Composant affichant la liste des associations entre entreprises utilisatrices et agences d'intérim
 */
const AssociationsTable: React.FC<AssociationsTableProps> = ({
  organizations,
  interimAgency,
  itemPath,
}) => {
  const tableColumns = useListTableColumns(organizations, interimAgency, itemPath)

  return (
    <Table
      columns={tableColumns}
      data={organizations.filter(organization =>
        organization?.associations?.some(association => {
          const interimAgency = association.interimAgency as InterimAgency
          return interimAgency && interimAgency._id === interimAgency._id
        }),
      )}
      noDataMessage="Aucune EU à afficher"
    />
  )
}

export default AssociationsTable

// Hook déplacé dans le même fichier
const useListTableColumns = (
  organizations: Employer[],
  interimAgency: InterimAgency,
  itemPath?: string,
): Column[] => {
  const getAssociation = (employer: Employer): Employer['associations'][0] | undefined => {
    return employer.associations.find(association => {
      return compareDocsById(association.interimAgency, interimAgency)
    })
  }
  return React.useMemo(
    () =>
      [
        {
          Header: 'Nom',
          accessor: 'name',
          Cell: (data: any) => {
            const organization: Employer = data.cell.row.original
            return (
              <ResourceLinkCell
                resource={organization}
                path={itemPath || '/job-titles/'}
                label={organization.name}
              />
            )
          },
        },
        {
          Header: "Statut de l'invitation",
          accessor: 'status',
          Cell: (data: any) => {
            const association = getAssociation(data.cell.row.original)
            //TODO: refactor component and type

            return association ? <RoleStatus role={association} showDate /> : null
          },
        },
        {
          Header: 'Invité le',
          accessor: 'createdAt',
          Cell: (data: any) => {
            const association = getAssociation(data.cell.row.original)
            return formatCompleteDate(association?.createdAt)
          },
        },
      ] as Column[],
    [organizations],
  )
}
